import * as React from 'react';
import { Form } from '@lon/mathnation-suit/components';
import { useQueryParams } from '@lon/mathnation-suit/hooks';
import { getRolesWithDashboardAccess } from '@lon/mathnation-suit/utils';
import { isDevMode } from '@lon/shared/constants';
import { UserTypeEnum, useGetLookUpRolesLazyQuery } from '@lon/shared/requests';
import { FormValues, LoginState, getValidation, onSubmit } from './duck';
import { MFAForm, PasswordForm } from './components';

interface LoginFormProps {
  onChangeState(): void;
  onForgot(): void;
}

const LoginForm: React.FC<LoginFormProps> = ({ onForgot }) => {
  const [params] = useQueryParams();
  const [state, setState] = React.useState<LoginState>(LoginState.Password);
  const [getUserRoles] = useGetLookUpRolesLazyQuery();

  const handleSubmit = (values: FormValues) =>
    onSubmit({
      ...values,
      district: params.district,
      isMFA: state === LoginState.MFA,
      setLoginState: setState,
      onSuccess: async (user) => {
        const userRoles = await getUserRoles({
          variables: {
            // @ts-ignore
            ids: user?.userRoles?.map(({ roleId }) => roleId),
          },
        });
        const hasDashboardAccess = !!getRolesWithDashboardAccess(
          userRoles.data?.lookupRoles
        ).length;

        const path =
          user?.type === UserTypeEnum.Admin
            ? '/platform-admin'
            : `${process.env.NX_SUIT_URL}${
                hasDashboardAccess ? '/dashboard' : ''
              }`;

        const { redirectTo } = params;
        const url = redirectTo ?? path;

        window.location.href = isDevMode()
          ? `https://local.stem.dev.stemscopes-v4-dev.aws.acceleratelearning.com:4206/mathnation`
          : url;
      },
    });

  return (
    <Form<FormValues>
      {...getValidation(state === LoginState.MFA)}
      mode="onSubmit"
      onSubmit={handleSubmit}
    >
      {() => {
        if (state === LoginState.MFA) {
          return <MFAForm onCancel={() => setState(LoginState.Password)} />;
        } else {
          return <PasswordForm onForgot={onForgot} />;
        }
      }}
    </Form>
  );
};

export default LoginForm;
